export default __webpack_public_path__ + "static/media/Postman1.89a952d4.svg";